/** @format */

import Button from "components/Button2";
import Input from "components/FormikInput";
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import * as AuthActions from "store/action/AuthAction";
import * as yup from "yup";

const initialValues = {
  current_password: "",
  new_password: "",
  confirm_password: "",
};

const validationSchema = yup.object({
  current_password: yup.string().required("Enter your current password"),
  new_password: yup
    .string()
    .min(8, "At least 8 characters")
    .required("Enter a new password"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("new_password")], "Passwords do not match")
    .required("Confirm your new password"),
});

function SecurityTab({ onSuccess }) {
  const onSubmit = async (values, { resetForm, setSubmitting }) => {
    const response = await AuthActions.MERCHANT_CHANGE_PASSWORD({
      current_password: values.current_password,
      new_password: values.new_password,
    });
    if (response?.status === 200) {
      toast.success("Password updated");
      resetForm();
      onSuccess?.();
    } else if (response?.status === 401) {
      toast.error("Current password is incorrect");
    } else {
      toast.error("Could not update your password. Please try again.");
    }
    setSubmitting(false);
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <p className="text-[0.9rem] text-[#868B8C] m-0">
        Used to sign in with a username and password instead of Google.
      </p>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="flex flex-col gap-4">
            <Input
              type="password"
              name="current_password"
              label="Current password"
              required
            />
            <Input
              type="password"
              name="new_password"
              label="New password"
              required
            />
            <Input
              type="password"
              name="confirm_password"
              label="Confirm new password"
              required
            />
            <Button
              Size="md"
              title={isSubmitting ? "Updating..." : "Update password"}
              background={"#2D6B4D"}
              color={"#ffff"}
              border="none"
              type="submit"
              disabled={isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default SecurityTab;
